import React from 'react'
import {Route, Link} from 'react-router-dom'
import {Breadcrumb, BreadcrumbItem} from 'reactstrap'
import routes from '../../routes'

const findRouteName = url => routes[url]

const getPaths = (pathname) => {
  const paths = ['/']

  if (pathname === '/') return paths

  pathname.split('/').reduce((prev, curr, index) => {
    const currPath = /profiles/.test(prev) ? `${prev}/profile` : `${prev}/${curr}`
    paths.push(currPath)
    return currPath
  })
  return paths
}

const BreadcrumbsItem = ({...rest, match}) => {
  const routeName = findRouteName(match.url)
  if (routeName && routeName.name) {
    return (
      match.isExact ?
        (
          <BreadcrumbItem active>{routeName.name}</BreadcrumbItem>
        ) :
        [
          <BreadcrumbItem key={`${routeName.name}-1`}>
            <Link to={match.url || ''}>
              {routeName.name}
            </Link>
          </BreadcrumbItem>,
          routeName.nameSingular ? <BreadcrumbItem key={`${routeName.name}-2`} active>{routeName.nameSingular}</BreadcrumbItem> : null
        ]
    )
  }
  return null
}

const Breadcrumbs = ({...rest, location : {pathname}, match}) => {
  const paths = getPaths(pathname)
  const items = paths.map((path, i) => <Route key={i++} path={path} component={BreadcrumbsItem}/>)

  return (
    <Breadcrumb>
      {items}
    </Breadcrumb>
  )
}

export default props => (
  <div>
    <Route path="/:path" component={Breadcrumbs} {...props} />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js